import frappe from '../frappe';

export async function createCheckUser(userData) {
  try {
    // Buscar cliente por nombre (custom_carne pendiente de que admin agregue el campo)
    const { data } = await frappe.get(
      `/api/resource/Customer?filters=[["customer_name","=","${userData.name}"]]&fields=["name","customer_name"]&limit=1`
    );

    if (data.data.length > 0) {
      return { id: data.data[0].name };
    }

    // Crear nuevo cliente
    const { data: newCustomer } = await frappe.post('/api/resource/Customer', {
      customer_name: userData.name,
      customer_type: 'Individual',
      mobile_no: userData.numero || '',
      // custom_carne: userData.carne, // pendiente: admin debe agregar este campo
    });

    return { id: newCustomer.data.name };
  } catch (error) {
    console.error('Error al registrar/verificar usuario:', error.response?.data || error.message);
    throw error;
  }
}
